let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iEvs6")).then(() => parcelRequire('bppNh'));